import axiosInstance from '../axios';

const authService = {
  // 로그인
  login: async (username, password) => {
    const response = await axiosInstance.post('/api/admin/managers/login', { username, password });
    console.log('로그인 응답:', response);
    const data = response.data;
    
    console.log('API 응답 전체:', data);
    
    // HTML 응답인지 확인 (잘못된 응답)
    if (typeof data === 'string' && (data.includes('<!DOCTYPE') || data.includes('<html'))) {
      throw new Error('서버에서 올바른 응답을 받지 못했습니다.');
    }
    
    // 토큰 저장 (다양한 응답 형식 처리)
    let token = null;
    
    if (typeof data === 'string' && !data.includes('<')) {
      // 응답이 직접 토큰 문자열인 경우 (HTML이 아닌 경우만)
      token = data;
    } else if (data && typeof data === 'object') {
      // 객체인 경우 다양한 키 이름 시도
      token = data.accessToken || data.token || data.access_token || 
              data.jwt || data.Authorization || data.authorization ||
              data.data?.accessToken || data.data?.token;
    }
    
    console.log('추출된 토큰:', token);
    
    if (token && typeof token === 'string' && !token.includes('<')) {
      localStorage.setItem('accessToken', token);
      // adminInfo가 있으면 adminInfo를 user로 저장, 없으면 전체 data 저장
      const userInfo = data.adminInfo || data;
      localStorage.setItem('user', JSON.stringify(userInfo));
      console.log('토큰 저장 완료');
    } else {
      console.warn('유효한 토큰을 찾을 수 없습니다. 응답:', data);
      throw new Error('로그인 응답에서 토큰을 찾을 수 없습니다.');
    }
    
    return data;
  },

  // 회원가입
  signup: async (userData) => {
    const response = await axiosInstance.post('/api/admin/managers', userData);
    return response.data;
  },

  // 로그아웃
  logout: () => {
    localStorage.removeItem('accessToken');
    localStorage.removeItem('user');
  },

  // 현재 사용자 정보 가져오기
  getCurrentUser: () => {
    const user = localStorage.getItem('user');
    try {
      return user ? JSON.parse(user) : null;
    } catch {
      return null;
    }
  },

  // 토큰 가져오기
  getToken: () => {
    return localStorage.getItem('accessToken');
  },

  // 토큰 확인 (HTML이 저장된 경우 무효 처리)
  isAuthenticated: () => {
    const token = localStorage.getItem('accessToken');
    // 토큰이 HTML인 경우 무효 처리
    if (token && (token.includes('<!DOCTYPE') || token.includes('<html'))) {
      localStorage.removeItem('accessToken');
      localStorage.removeItem('user');
      return false;
    }
    return !!token;
  },

  // 잘못된 토큰 정리
  clearInvalidToken: () => {
    const token = localStorage.getItem('accessToken');
    if (token && (token.includes('<!DOCTYPE') || token.includes('<html') || token.includes('<'))) {
      localStorage.removeItem('accessToken');
      localStorage.removeItem('user');
      console.log('잘못된 토큰이 제거되었습니다.');
      return true;
    }
    return false;
  }
};

export default authService;
